import React, { createContext, useContext, useEffect } from 'react';
import useGetUsers from '../hooks/useGetUsers';

type UserContextType = ReturnType<typeof useGetUsers> | null;

const UserContext = createContext<UserContextType>(null);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { usersList, fetchUsers } = useGetUsers();

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return <UserContext.Provider value={{ usersList, fetchUsers }}>{children}</UserContext.Provider>;
};

export const useUsers = () => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error('useUsers must be used within a UserProvider');
  }

  return context;
};
